/**
 * The faces a player can say, as drawings rather than as typed characters.
 *
 * A system emoji is laid out differently by every engine - two of them hang the
 * glyph off the left of an advance wider than the art, a third centres a larger
 * glyph inside the same advance - and nothing readable from CSS or the DOM
 * tells those cases apart. A lamp cannot be centred on all of them at once, so
 * the board draws its own: static/img/faces holds one SVG per reaction, named
 * by codepoint, and the file's viewBox is what the lamp centres.
 *
 * The reaction itself stays the emoji everywhere else - it is what the server
 * validates, what Firestore stores and what a screen reader reads out. Only the
 * picture of it is ours. Mirrors faceID in cmd/server/templates.go.
 */

/** The file name for a glyph: its codepoints in hex, joined by hyphens. */
export function faceId(glyph) {
    return [...String(glyph)]
        .map((ch) => ch.codePointAt(0))
        // A variation selector picks between a text and an emoji rendering of
        // the same character, and neither is what draws this.
        .filter((cp) => cp !== 0xfe0e && cp !== 0xfe0f)
        .map((cp) => cp.toString(16))
        .join('-');
}

/** The glyphs in a stored reaction string. Mirrors strings.Fields in Go. */
export function faceList(reactions) {
    if (typeof reactions !== 'string') return [];
    return reactions.split(/\s+/).filter(Boolean);
}
